class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-drawer-quick-add]');
  if (!button || button.disabled) return;

  const drawer = button.closest('cart-drawer');
  const product = button.closest('.drawer-quick-shop__product');
  const select = product.querySelector('[data-quick-variant]');
  const status = drawer.querySelector('[data-quick-status]');

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  status.textContent = 'Adding…';

  let added = false;

  try {
    const response = await fetch(
      `${window.Shopify.routes.root}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(select.value), quantity: 1 }],
          sections: drawer.getSectionsToRender().map(s => s.id),
          sections_url: window.location.pathname
        })
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description || 'Could not add this item.'
      );
    }

    added = true;

    const sectionsReady = drawer.getSectionsToRender()
      .every(section => result.sections?.[section.id]);

    if (!sectionsReady) {
      throw new Error('Cart display could not be refreshed.');
    }

    drawer.renderContents(result);

    const refreshedStatus =
      drawer.querySelector('[data-quick-status]');
    if (refreshedStatus) {
      refreshedStatus.textContent = 'Added to your cart.';
    }

    drawer.querySelector('[data-drawer-quick-add]')?.focus();
  } catch (error) {
    status.textContent = added
      ? 'Item added. Refresh the page to see your updated cart.'
      : error.message;
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
  (() => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    let deadline = null;
    let interval = null;
    let running = false;

    function paint() {
      const display = drawer.querySelector('[data-cart-countdown]');
      if (!display || deadline === null) return;

      const seconds = Math.max(
        0,
        Math.ceil((deadline - Date.now()) / 1000)
      );

      const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
      const remainder = String(seconds % 60).padStart(2, '0');
      const value = `${minutes}:${remainder}`;

      if (display.textContent !== value) {
        display.textContent = value;
      }

      if (seconds === 0) {
        clearInterval(interval);
        interval = null;
      }
    }

    function sync() {
      const isOpen = drawer.classList.contains('active');
      const hasItems = !!drawer.querySelector('[data-cart-countdown]');

      if (!isOpen || !hasItems) {
        clearInterval(interval);
        interval = null;
        deadline = null;
        running = false;
        return;
      }

      if (!running) {
        running = true;
        deadline = Date.now() + 10 * 60 * 1000;
        interval = setInterval(paint, 250);
      }

      paint();
    }

    new MutationObserver(sync).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    sync();
  })();
  